import styled from 'styled-components';
import whatsapp from './assets/whatsapp.png';
import instagram from './assets/instagram.png';
import google from './assets/google.png';
import facebook from './assets/facebook.png';

const RodapeEstilizado = styled.footer`
height: 100%;
color: white;
padding: 1em;
background-color:  ${props => props.theme.cores.primaria};
text-align: center;
`


const ListaEstilizada = styled.ul`
display: flex;
justify-content: space-around;
width: 10%;
margin: 1em auto;
`


const ItemEstilizado = styled.li`
list-style-type: none;
`


function Rodape() {
    return (
        <RodapeEstilizado>
            <ListaEstilizada>
                <ItemEstilizado>
                    <a href="#">
                        <img src={facebook} alt="logo do facebook" />
                    </a>
                </ItemEstilizado>
                <ItemEstilizado>
                    <a href="https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=" target="_blank" rel="noopener noreferrer" >
                        <img src={whatsapp} alt="logo do whatsapp" />
                    </a>
                </ItemEstilizado>
                <ItemEstilizado>
                    <a href="#">
                        <img src={google} alt="logo do google" />
                    </a>
                </ItemEstilizado>
                <ItemEstilizado>
                    <a href="#">
                        <img src={instagram} alt="logo do instagram" />
                    </a>
                </ItemEstilizado>

            </ListaEstilizada>
            <p>Rua Victório Santim, n:401 - Sala 6 - Vila Carmosina, São Paulo - SP, 08290-001</p>
            
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d820.7246774259081!2d-46.451656267401134!3d-23.539100434953628!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce67aac1d692ef%3A0x10ad5aa86933af3f!2sPSI%20Rose%20Marina!5e0!3m2!1spt-BR!2sbr!4v1707489495905!5m2!1spt-BR!2sbr"
                width="300"
                height="100"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy">
            </iframe>
            <p>2024 © Desenvolvido por DW NEW SOFTWARE </p>
        </RodapeEstilizado>
    )
}

export default Rodape;
